import { Button, FormControl, Grid, InputLabel, MenuItem, OutlinedInput, Select, Stack, Typography, useTheme } from '@mui/material';
import useMain from 'hooks/useMain';
import React, { useImperativeHandle, useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useLocation } from 'react-router';
import Swal from 'sweetalert2';
import { handleAlertMessage } from 'utils/common';
import { Button1, Button2 } from './Button';
import CusFormField from './CusFormField';
import CusMultipleSelect from './CusMutipleSelect';

const CusMultipleFilter = React.forwardRef(
  (
    {
      title,
      filters = [],
      handleSubmit: _handleSubmit = (data) => {},
      handleError: _handleError = (err) => {
        const errStrings = Object.entries(err).map(([k, v]) => {
          return `${k} is ${v.type}`;
        });
        handleAlertMessage({
          text: errStrings,
          title: '',
          showCancelButton: false
        });
      },
      buttonLabel,
      buttonProps,
      renderLabel,
      toggleDrawer
    },
    ref
  ) => {
    const {
      control,
      setError,
      handleSubmit,
      getValues,
      setValue,
      formState: { errors },
      reset,
      watch
    } = useForm({});

    useImperativeHandle(
      ref,
      () => {
        return {
          setValue,
          getValues,
          reset
        };
      },
      []
    );

    const theme = useTheme();
    const { t } = useMain();
    const _title = title || t('FILTERS');
    const _buttonLabel = buttonLabel || t('FILTER');
    const location = useLocation();
    const isBatchUpdate = location.pathname.includes('batchUpdate');
    const isReport = location.pathname.includes('report');
    // const [openSiderbar, setOpenSidebar] = useState(false);

    return (
      <Stack p={3}>
        {/* add theme color */}
        <Typography variant="h4" color={theme.palette.primary[400]}>
          {_title}
        </Typography>
        <form onSubmit={handleSubmit(_handleSubmit, _handleError)}>
          <Grid spacing={1} container pt={5}>
            {filters.map((props) => (
              <CusFormField
                key={`${props.id}-select`}
                {...props}
                itemProps={{
                  sm: 4.5
                }}
                control={control}
              />
            ))}{' '}
            <Grid item sm={3} display="flex" justifyContent="start-end" alignItems="flex-end">
              {/* <Button
                size="medium"
                variant="text"
                type="submit"
                sx={{ bgcolor: theme.palette.primary[400], color: 'white', borderRadius: '21px', mb: '2px' }}
                {...buttonProps}
              >
                {_buttonLabel}
              </Button>
              {!isBatchUpdate && (
                <Button
                  sx={{ ml: [0, 2], mt: [2, 0], mb: '2px', bgcolor: 'white', color: theme.palette.primary[400], borderRadius: '21px' }}
                  variant="outlined"
                  onClick={toggleDrawer}
                >
                  {t('ADVANCED_SEARCH')}
                </Button>
              )} */}
              <Button1
                text={_buttonLabel}
                type="submit"
                sx={{ ml: [0, 2], mt: [2, 0], mb: '2px' }}
                id={'multi-filter-submit-button'}
                {...buttonProps}
              />
              {!isBatchUpdate && !isReport && toggleDrawer && (
                <Button2
                  text={t('ADVANCED_SEARCH')}
                  sx={{ ml: [0, 2], mt: [2, 0], mb: '2px' }}
                  // variant="outlined"
                  onClick={toggleDrawer}
                />
              )}
            </Grid>
          </Grid>
        </form>
        {renderLabel}
      </Stack>
    );
  }
);

export default CusMultipleFilter;
